import * as React from "react";

import { cn } from "@/lib/utils";
import { P } from "../typography";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  isError?: boolean;
  label?: string;
  labelClassName?: string;
  containerClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      isError = false,
      label,
      labelClassName,
      containerClassName,
      ...props
    },
    ref
  ) => {
    const borderColor = isError ? "border-red-900" : "border-neutral-700";

    const inputElement = (
      <input
        type={type}
        className={cn(
          `border-input flex h-9 w-full rounded-lg border bg-input bg-transparent px-3 py-1 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 ${borderColor} text-primary placeholder:font-normal placeholder:tracking-normal placeholder:text-inputPlaceholderLight`,
          className
        )}
        ref={ref}
        {...props}
      />
    );

    if (label) {
      return (
        <div className={cn("flex flex-col gap-3", containerClassName)}>
          <P
            className={cn(
              "justify-center self-stretch text-white",
              labelClassName
            )}
          >
            {label}
          </P>
          {inputElement}
        </div>
      );
    }

    return inputElement;
  }
);

Input.displayName = "Input";

export default Input;
